import appConfig from "config.json";
import { loadBrandParam, urlParams } from "utils/paramsValidation";

let customTheme = false;
let bodyMutationObserver;
let themeLoaderTimeout = null;

const timeoutDuration = 1000;
const brand = loadBrandParam();
const { brands, globalThemes, lowPriorityThemes, highPriorityThemes } =
	appConfig;
const cdnThemes = brands[brand].cdnThemes || [];
const allowedThemes = globalThemes
	.concat(brands[brand].themes || [])
	.concat(cdnThemes);

const applyLoadedThemeClass = () => {
	if (!document?.body.classList.contains("theme-loaded")) {
		document?.body.classList.add("theme-loaded");
	}
	if (themeLoaderTimeout) {
		clearTimeout(themeLoaderTimeout);
		themeLoaderTimeout = null;
	}
};

const loadThemeCss = (theme, cdnUrl, cdnAssetsUrl) => {
	const isCdnTheme = cdnThemes.includes(theme);
	const fileName = `${isCdnTheme ? cdnAssetsUrl : cdnUrl}/themes/${
		isCdnTheme ? `${theme}/` : ""
	}${theme}.min.css`;
	if (!document?.querySelector('link[href="' + fileName + '"]')) {
		const link = document?.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = fileName;
		link.onload = applyLoadedThemeClass;
		link.onerror = applyLoadedThemeClass;
		document?.head.appendChild(link);
	}
	if (highPriorityThemes.includes(theme)) {
		document?.body.classList.add("disableCustomNavigationTheme");
	}
};

const findThemeInClassesList = (setNewConfig, cdnUrl, cdnAssetsUrl) => {
	const classes = document?.body.classList;
	for (let index = 0; index < allowedThemes.length; index++) {
		if (classes.contains(allowedThemes[index])) {
			setNewConfig("theme", allowedThemes[index]);
			loadExternalThemeStyles(allowedThemes[index], cdnUrl, cdnAssetsUrl);
			return true;
		}
	}
	return false;
};

const extractThemeFromBodyClasses = (setNewConfig, cdnUrl, cdnAssetsUrl) => {
	const theme = findThemeInClassesList(setNewConfig, cdnUrl, cdnAssetsUrl);
	if (!theme && !bodyMutationObserver) {
		bodyMutationObserver = new MutationObserver(() => {
			findThemeInClassesList(setNewConfig, cdnUrl, cdnAssetsUrl);
		});
		bodyMutationObserver.observe(document?.body, {
			attributeFilter: ["class"],
		});
	}
};

const loadTheme = (setNewConfig, cdnUrl, cdnAssetsUrl) => {
	const theme = urlParams.get("theme") || "";
	if (theme) {
		loadExternalThemeStyles(theme, cdnUrl, cdnAssetsUrl);
		setNewConfig("theme", theme);
	} else {
		extractThemeFromBodyClasses(setNewConfig, cdnUrl, cdnAssetsUrl);
	}
	if (!themeLoaderTimeout) {
		themeLoaderTimeout = setTimeout(
			() => applyLoadedThemeClass(),
			timeoutDuration
		);
	}
};

export const loadExternalThemeStyles = (theme, cdnUrl, cdnAssetsUrl) => {
	if (theme && allowedThemes.includes(theme)) {
		if (customTheme && lowPriorityThemes.includes(theme)) return;
		loadThemeCss(theme, cdnUrl, cdnAssetsUrl);
	}
};

export const loadThemeConfigurations = (setNewConfig, cdnUrl, cdnAssetsUrl) => {
	loadTheme(setNewConfig, cdnUrl, cdnAssetsUrl);
};

export const preloadThemeCss = (theme, cdnUrl, cdnAssetsUrl) => {
	if (!theme || !allowedThemes.includes(theme)) return;
	loadThemeCss(theme, cdnUrl, cdnAssetsUrl);
};
